// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Bji","label":"styles_label__2wtFD"};